import React, { Component } from 'react'
import Seo from "./Seo"
import Footer from './Footer'


//  class TermsConditions extends Component {
//   render() {
//     return (
//       <div>
//         <div className='container mt-5'>
//           <h1 className='py-5'>Terms And Conditions</h1>
//           <p>``All the forces in the world are not so powerful as an idea whose time has come’’
//             – Victor Hugo More than it inspired us, it upheld our conviction to take the plunge.
//             So took the birth of Pulse Labs!<br></br></p>
//             <h4>Our Pulse…</h4>
//             <p>Life for us at Pulse Labs is about thriving on ideas and insights that are ground-breaking.
//                Contradictory it may sound, but our people with diverse mind-sets makes this task more easily.
//                What we have in common is the vision and passion for excellence. Outcome is in the form of solutions
//                 that are futuristic. For us, Innovation means Life. Welcome to Pulse Labs!<br></br></p>
//                 <h4>The Market Pulse…</h4> <p>Financial Advisory Profession in India is moving to its next level.
//             The transition is as much challenging as exciting. Dwindling commissions has forced Financial
//             Advisors to look at alternate revenue models. Regulatory Oscillations, Irrational Client Behaviour,
//             Volatile Markets are adding to their woes.<br></br></p>
//             <h4>The Business Pulse…</h4>
//             <p>Pulse Labs as a Business House cater to the B2B segment in the Financial Services space.
//                We focus on creating solutions cemented with Technology, Research & Analytics, which are
//                best suited for the GenNext Advisory Firm. We offer this as APIs to FinTechs and Apps to IFAs (RIAs & MFDs)</p>
//         </div>
//         <Footer/>
//         <Seo />
//       </div>
//     )
//   }
// }

// export default  TermsConditions

const TermsAndConditions = () => {
  return (
    <div>
    <div className='container mt-5'>
      <h1 className='py-5'>Terms & Conditions</h1>
      <p style={styles.updated}>Last Updated: 01-12-2025</p>

      <div style={styles.section}>
         <p>
          Welcome to <strong>Pulse Labs Research & Technology Solutions Pvt. Ltd.</strong>
          (“Pulse Labs”, “We”, “Us”, “Our”). By accessing our website{" "}
          <a
            href="https://pulselabs.co.in"
            target="_blank"
            rel="noopener noreferrer"
            style={styles.link}
          >
            pulselabs.co.in
          </a>
          , applications (“FinApp”), APIs, dashboards, or any related services
          (collectively, the “Platform”), you agree to these Terms & Conditions.
        </p>
        <p>If you do not agree, please discontinue using the Platform.</p>
      </div>

      <h2 style={styles.heading}>1. Nature of Services</h2>
      <ul style={styles.list}>
        <li><strong>API Suite</strong> for Robos, Banks, FinTechs, MFOs:
          <ul>
            <li>KYC & onboarding APIs</li>
            <li>RTA file processing</li>
            <li>e-CAS reading</li>
            <li>Risk profiling</li>
            <li>Portfolio reporting & analytics</li>
            <li>Model portfolios</li>
            <li>Goal planning</li>
            <li>MF transaction APIs</li>
            <li>Multi-asset analytics</li>
          </ul>
        </li>

        <li><strong>App Suite (FinApp Platform)</strong> for IFAs, RIAs, MFOs:
          <ul>
            <li>Research Toolkit</li>
            <li>Portfolio Review / Optimization</li>
            <li>Goal Planning</li>
            <li>Client Login</li>
            <li>Dashboarding</li>
            <li>White-labeled website & mobile app</li>
            <li>Advisor tools</li>
            <li>Reporting suite</li>
          </ul>
        </li>
      </ul>

      <h2 style={styles.heading}>2. Not a SEBI Registered Entity</h2>
      <p>Pulse Labs:</p>
      <ul style={styles.list}>
        <li>is NOT a SEBI-registered Investment Advisor (RIA)</li>
        <li>does NOT provide investment advice or buy/sell recommendations</li>
        <li>provides outputs only for informational & educational purposes</li>
      </ul>
      <p>
        Mutual fund investments are subject to market risks.  
        Users must consult appropriate licensed professionals.
      </p>

      <h2 style={styles.heading}>3. Eligibility</h2>
      <ul style={styles.list}>
        <li>You are above 18 years of age</li>
        <li>Legally capable of entering into a contract</li>
        <li>An MFD, RIA, IFA, or institution</li>
        <li>Will comply with applicable laws</li>
      </ul>

      <h2 style={styles.heading}>4. User Responsibilities</h2>
      <ul style={styles.list}>
        <li>NOT to present outputs as regulated advice</li>
        <li>NOT to misuse data or reverse engineer systems</li>
        <li>NOT to upload unlawful content</li>
        <li>Keep login credentials confidential</li>
        <li>Ensure client consent for uploading PAN / CAS / data</li>
      </ul>

      <h2 style={styles.heading}>5. Data Collected</h2>
      <ul style={styles.list}>
        <li>Contact information</li>
        <li>KYC identifiers</li>
        <li>Portfolio & financial data</li>
        <li>Device/browser usage data</li>
        <li>Goal & risk profiling data</li>
        <li>Transaction triggers (via partner APIs)</li>
      </ul>

      <h2 style={styles.heading}>6. CAS Handling & Security</h2>
      <p>CAS data is processed securely on AWS with encryption in transit & at rest.</p>

      <h2 style={styles.heading}>7. Third-Party Integrations</h2>
      <p>The Platform integrates with BSE Star MF, AWS, RTAs (CAMS, KFin), AMFI, etc.</p>

      <h2 style={styles.heading}>8. Subscription, Billing & Refunds</h2>
      <ul style={styles.list}>
        <li>Fees payable upfront</li>
        <li>GST non-refundable</li>
        <li>Pro-rata refunds for unused tenure</li>
        <li>Plans may auto-renew</li>
        <li>Pricing may change without notice</li>
      </ul>

      <h2 style={styles.heading}>9. Intellectual Property</h2>
      <p>All software, algorithms, analytics, visuals, and reports belong to Pulse Labs.</p>

      <h2 style={styles.heading}>10. Limitation of Liability</h2>
      <p>
        Pulse Labs is not liable for financial losses, data delays, inaccuracies, or
        third-party outages. Use of Platform is at user’s own risk.
      </p>

      <h2 style={styles.heading}>11. Indemnification</h2>
      <p>Users indemnify Pulse Labs for misuse, regulatory violations, or data misuse.</p>

      <h2 style={styles.heading}>12. Termination</h2>
      <p>Access may be terminated upon violation; refunds follow pro-rata policy.</p>

      <h2 style={styles.heading}>13. Modifications</h2>
      <p>Terms may be modified anytime; continued use means acceptance.</p>

      <h2 style={styles.heading}>14. Governing Law</h2>
      <p>Governed by Indian law. Bangalore courts have exclusive jurisdiction.</p>

      <h2 style={styles.heading}>15. Contact</h2>
      <p>
        <strong>Pulse Labs Research & Technology Solutions Pvt Ltd</strong><br />
        📧 support@pulselabs.co.in<br />
        🌐 pulselabs.co.in
      </p>
      </div>
            <Footer/>
       <Seo />
    </div> 
  );

  
};

// Basic styling
const styles = {

  title: {
    fontSize: "32px",
    marginBottom: "10px",
  },
  updated: {
    fontSize: "14px",
    color: "#666",
  },
  section: {
    margin: "20px 0",
  },
  heading: {
    marginTop: "30px",
    fontSize: "22px",
  },
  list: {
    paddingLeft: "20px",
  },
};

export default TermsAndConditions;